import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.45214 10.8687L20.9997 4.44532M8.97026 10.8627L3.84348 5.43678C3.24097 4.79911 3.69304 3.75 4.57035 3.75H20.5045C21.2772 3.75 21.758 4.58899 21.3673 5.25564L13.1848 19.2171C12.7385 19.9785 11.5965 19.8306 11.3589 18.9806L9.20648 11.2803C9.16279 11.124 9.08172 10.9807 8.97026 10.8627Z",
      stroke: "var(--icon-color, #28373c)",
      "stroke-width": "var(--icon-stroke-width, 1.5)",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }